export const environment = {
  production: false,
  apiBaseUrl: 'https://acs.proxy-preprod.modulr.fr',
  apiEnv: '',
  apiBase: '',
  useFakeHttp: false
};
